import React from 'react'
import FileFormatIcon from '../../../../common/FileFormatIcon'
import { DocumentWithText } from '../../../../../lib/api/types/document.interfaces'
import { Button, Tooltip } from '../../../../ui'
import buildSnippetAroundHighlight from '../../../../../lib/utils/files/buildSnippetAroundHighlight'
import { Visibility } from '@mui/icons-material'

interface QuickSearchDialogItemProps {
	item: DocumentWithText
	onPreview: (
		id: string,
		versionId?: string | null,
		type?: number | null
	) => void
}

const QuickSearchDialogItem: React.FC<QuickSearchDialogItemProps> = ({
	item: { id, name, versionId, type, text = '' },
	onPreview,
}) => {
	const snippetHtml = buildSnippetAroundHighlight(text, 70)
	return (
		<div className="flex flex-col gap-3 p-4 box-border w-full bg-background-light dark:bg-background-light-dark dark:hover:bg-background-light-dark hover:bg-background-light-hover duration-default rounded-lg">
			<div className="flex items-center w-full gap-2">
				<FileFormatIcon
					fileName={name}
					isFolder={false}
					className="fill-text-secondary w-7 h-7 ml-1"
				/>

				<Tooltip label={name}>
					<p className="text-text-main  dark:text-text-table-dark truncate font-bold text-sm">
						{name}
					</p>
				</Tooltip>

				<Button
					variant="secondary"
					className="min-w-20 h-7 box-border px-2 text-base font-normal ml-auto"
					leftIcon={<Visibility className="w-4 h-4" />}
					label="Open"
					onClick={() => {
						onPreview(id, versionId, type)
					}}
				/>
			</div>
			{!!text && (
				<p
					dangerouslySetInnerHTML={{
						__html: snippetHtml,
					}}
					className="text-text-main dark:text-text-table-dark text-base"
				></p>
			)}
		</div>
	)
}

export default QuickSearchDialogItem
